import React from "react";
import styles from "./unauthorised.module.scss";

const Unauthorised = () => {
  return (
    <>
      <div className={styles.pageContainer}>
        <h2>Unauthorized</h2>
        <h3>
          You do not have any permissions to access this website. <br />
          Please contact your adminstrator
        </h3>
      </div>
    </>
  );
};

export default Unauthorised;
